import React from "react";
import { useAddSourceWebsite } from "@/api/knowledge-source/add-source-website";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import useOnboardingData from "@/store/onboarding-data";
import useGlobalPermission from "@/store/user-permissions";
import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";
import useSocketMessage from "@/store/socket-message";

const MultiPageSource = () => {
    const [pageURL, setPageURL] = React.useState("");
    const { mutate: addSourceURL, isPending } = useAddSourceWebsite();
    const { storeData } = useOnboardingData();
    const { setMessages, setConnectionStatus, addMessage } = useSocketMessage();

    const handleAddSource = () => {
        if (!pageURL) {
            toast.error("Please enter a valid URL");
            return;
        }
        
        // Call the add source API which returns crawl_id in response
        addSourceURL({ url: pageURL }, {
            onSuccess: (data) => {
                // Check if we got a crawl_id in the response
                if (data?.data?.crawl_id) {
                    // Start WebSocket connection with the received crawl_id
                    setConnectionStatus("Connected");
                    setMessages(["Crawling started..."]);
                    
                    // Connect to WebSocket using storeData.id (as per the original WebSocket pattern)
                    const ws = new WebSocket(`${import.meta.env.VITE_CRAWLER_BASE_URL}/${storeData?.id}`);
                    
                    ws.onopen = () => {
                        setConnectionStatus("Connected");
                    };

                    ws.onmessage = (event) => {
                        const data = event.data;
                        if (data === "Crawling complete.") {
                            setConnectionStatus("Disconnected");
                            setMessages([]);
                            ws.close();
                        } else {
                            addMessage(data);
                        }
                    };

                    ws.onerror = (error) => {
                        console.error("WebSocket error:", error);
                        setConnectionStatus("Error");
                    };

                    ws.onclose = () => {
                        setConnectionStatus("Disconnected");
                    };
                }
            },
            onError: (error) => {
                console.error("Error adding source:", error);
                toast.error(error.message || "Error adding source");
            }
        });
    };

    const { permissionList } = useGlobalPermission();
    const trainingPermission = permissionList.find((item) => item.module.name === "AI_Training");

    return (
        <div>
            <h3 className="mb-4 font-bold">Website URL</h3>
            <Input
                disabled={!trainingPermission?.can_create || isPending}
                className="mb-3 py-6"
                placeholder="Enter the page url here"
                value={pageURL}
                onChange={(e) => setPageURL(e.target.value)}
            />
            <p className="mb-4 text-sm">This action will save the information from the entire website.</p>
            <KnowledgeSourceButtons 
                onSubmit={handleAddSource} 
                loading={isPending} 
            />
        </div>
    );
};

export default MultiPageSource;